import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tax'
})
export class TaxPipe implements PipeTransform {
  transform(item: any): any {
    let ret = 0;
    if(item.price.slab) {
      ret = parseFloat(item.price.slab) * .06;
    }

    return ret.toFixed(2);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/tax-pipe.ts